
<!--
 * @Description: 学生 详情 所获证书
 * @Author: PF
 * @Date: 2023-11-30 10:20:27
 * @LastEditors: PF
 * @LastEditTime: 2025-07-18 13:39:42
-->
<template>
  <div class="hp100" v-if="tableData.length">
    <el-table :data="tableData" border height="100%">
      <el-table-column label="证书名称" prop="zsmc" align="center" />
      <el-table-column label="证书编号" prop="zsbh" align="center" />
      <el-table-column label="证书类型" prop="zslx.name" align="center" />
      <el-table-column label="发放时间" width="137px" prop="ffsj" align="center" />
      <!-- 冻结列-Right BEGIN -->
      <el-table-column label="操作" width="80" fixed="right" align="center">
        <template #default="scope">
          <el-button link type="success" @click="openDetail=true; row=scope.row">详情</el-button>
        </template>
      </el-table-column>
      <!-- 冻结列-Right END -->
    </el-table>
  </div>
  <el-empty v-else class="hp100" description="暂无证书" />
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { loadSelect } from '@/api/common.js'
import detail from '@/pages/jiaowu/zhengshuguanli/zhengshufafang/detail.vue'

const props = defineProps({
  row: { type: Object, required: false }
})
const tableData = ref([])
const openDetail = ref(false)
const row = ref({})

watch(
  () => props.row,
  () => {
    if (props.row) {
      loadSelect({ url: '/api/v2/jiaowu/xueshengzhengshufafangjilu/list', data: tableData, parms: { xsid: props.row.id, order: 'xsxm', sort: 'desc' } })
    }
  },
  { deep: true, immediate: true }
)
</script>
